import React from 'react'
import { ReasonContainer, Label } from '../style/ReasonWMO.css'

const ReasonsListWMO = ({ reasonLabel, reasons }) => (
  <ReasonContainer>
    <Label>
      {reasonLabel || 'Return Details'}
    </Label>
    <ul>
      {reasons.map(list => (
        <li key={list.id}>
          {list.label}
        </li>
      ))}
    </ul>
  </ReasonContainer>
)

export default ReasonsListWMO
